<template>
<div class="template chatAllSystem">
  <el-row :gutter="24">
    <el-col :span="8">
      <div class="layoutCon" :style="{'minHeight':util.accDiv(height,1.15)+'px'}">
        <div class="inputChat">
          <el-input v-model="inputChatName" :placeholder="$t('im.chatAllSystem.inputChatName')"></el-input>
          <el-button type="primary" size="medium" @click="searchCon()">{{$t('im.bt.find')}}</el-button>
        </div>
        <div class="avaList" :style="{'maxHeight':util.accDiv(height,1.35)+'px'}">
          <ul>
            <li v-for="(item,index) in chatData">
              <div class="avaCon" @contextmenu.prevent="talkTo($event,'bb',index)">
                <i v-if="singleMessageCount[item.userToken]&&singleMessageCount[item.userToken]>0">{{singleMessageCount[item.userToken]}}</i>
                <img :src="util.isNotEmpty(item.imageAddress)?item.imageAddress:require('@/assets/IM/ava.png')"/>
                <span>{{item.displayName}}<em>{{item.names}}</em></span>
                <div class="talk_list" id="talk_list" ref="bb" @mouseleave="leave('bb',index)">
                  <ul>
                    <li @click="cueHim(item)">{{$t('im.chatAllSystem.cueHim')}}</li>
                    <li @click="personToPerson(item)">{{$t('im.chatAllSystem.personToPerson')}}</li>
                  </ul>
                </div>
              </div>
              <p>{{serviceStatusInfo[item.userToken]==0?$t('im.common.online'):serviceStatusInfo[item.userToken]==1?$t('im.common.business'):serviceStatusInfo[item.userToken]==2?$t('im.common.offline'):$t('im.common.offline')}}</p>
            </li>
          </ul>
        </div>
      </div>
    </el-col>
    <el-col :span="16">
      <div class="layoutCon">
        <chatRoom ref="myChild" :chatHeight="util.accDiv(height,1.15)+'px'" :maxHeight="util.accSub((util.accDiv(height,1.15)),190)" :clientChatInfo="0" :service="6"></chatRoom>
      </div>
    </el-col>
  </el-row>
  <!--客服私聊-->
  <el-dialog :visible.sync="serveSinglePop" class="tcChat" :before-close="cancelSingleChat">
      <chatRoom v-if="clientChatInfo&&serveSinglePop" :chatHeight="util.accDiv(height,1.6)+'px'" :maxHeight="util.accSub((util.accDiv(height,1.55)),190)" :clientChatInfo="clientChatInfo" :service="5"></chatRoom>
  </el-dialog>
</div>
</template>

<script>
  require('@/styles/IM/template.css');
  require('@/styles/IM/chatAllSystem.css');
  import chatRoom from '@/views/IM/model/chatRoom.vue'
  import Util from '@/utils/IM/tradeDataUtil'
  import apiChatSystem from "@/api/im/chatSystem"
  import { localRead} from '@/utils/tools'
  import imStore from '@/store/modules/im'
  export default {
    name: 'chatAllSystem',
    components: {chatRoom},
    computed:{
      avaList: {
        get() {
          if (Util.isNotEmpty(this.inputChatName)) {
            return this.originChatData.filter((value) => {
              if (!isNaN(this.inputChatName)) {
                return String(value.displayName).indexOf(this.inputChatName) > -1
              } else {
                return String(value.displayName).indexOf(this.inputChatName) > -1
              }
            })
          }else {
            return this.originChatData
          }
        }
      },
      serviceStatusInfo:{
        get() {
          return this.$store.state.im.serviceStatus
        }
      },
      singleMessageCount: {
        get() {
          return this.$store.state.im.singleMessageNums
        }
      },
    },
    data(){
      return{
        util: Util,
        height: '',
        userInfo: JSON.parse(localRead('sys_userInfo_IM')), //用户信息
        chatData:"",//客服列表
        originChatData:"",//客服列表
        inputChatName:"",
        clientChatInfo:'',//私聊客服信息
        serveSinglePop:false,//是否显示私聊
        chatStatusList: [
          { name: window.$t('im.common.online'), id: 0 },
          { name: window.$t('im.common.business'), id: 1 },
          { name: window.$t('im.common.offline'), id: 2 },
        ],//客服状态
      }
    },
    methods:{
      docHeight() {
        this.height = window.innerHeight || document.documentElement.clientHeight
      },
      /*查询关键词*/
      searchCon() {
        this.brushChatData(this.avaList)
      },
      // 全局关闭
      globalClick() {
        document.onclick = e => {
          if (e.target.className != 'talk_list') {
           if (document.getElementById("talk_list")) document.getElementById("talk_list").style.display = 'none'
          }
        }
      },
      // 获取元素的所有兄弟节点
      siblings (elm) {
        var a = []
        var p = elm.parentNode.children
        for (var i = 0, pl = p.length; i < pl; i++) {
          if (p[i] !== elm) a.push(p[i])
        }
        return a
      },
      // 右键点击头像
      talkTo(e, id, index) {
        let target
        if (e.target) {
          target = this.siblings(e.target.parentNode.parentNode)
        }
        this.commonGetTarget(target)
        this.$refs[id][index].style.display = 'block'
      },
      commonGetTarget(target) {
        target = target.filter(function(item) {
          return item.className != 'me'
        })
      },
      leave(id, index) {
        this.$refs[id][index].style.display = 'none'
      },
      // @功能
      cueHim(obj) {
        this.$refs.myChild.assignationMember(obj)
      },
      //客服私聊
      personToPerson(obj) {
        this.serveSinglePop = true
        let businessIds = []
        for (const i in obj.businessId) {
          businessIds.push(obj.businessId[i].code)
        }
        obj.businessIds = businessIds.join(',')
        this.clientChatInfo = obj
        imStore.dispatch('setSingleUserToken', obj.userToken)
        if (this.serveSinglePop) this.delSingleMessageCount(obj.userToken)
      },
      /*删除客服私聊消息数量*/
      delSingleMessageCount(fromToken) {
        let data = {
          from: fromToken,
          userToken: this.userInfo.userToken
        }
        apiChatSystem.deleteServiceSingleMessageCount(data).then(res => {
          if (res.code == 0) {
            if (res.result) {
              this.singleMessageCount[fromToken] = 0
              imStore.dispatch('setSingleMessageNums', JSON.parse(JSON.stringify(this.singleMessageCount)));
            }
          }
        })
      },
      cancelSingleChat(){
        this.serveSinglePop = false
        imStore.dispatch('setSingleUserToken', "")
      },
      /*刷选客服列表*/
      brushChatData(data) {
        let newData = JSON.parse(JSON.stringify(data))
        for (const i in newData) {
          newData[i].names = ''
          for (const j in newData[i].businessId) {
            newData[i].names += newData[i].businessId[j].name + ','
          }
          newData[i].names = newData[i].names.slice(0, newData[i].names.length - 1)
        }
        this.chatData = newData
      },
      /*初始化客服列表*/
      initThisList() {
        let data = { companyId: this.userInfo.companyId }
        apiChatSystem.getThisList(data).then(res => {
          if (res.code == 0) {
            if (res.result && res.result.length > 0) {
              let oldData = JSON.parse(JSON.stringify(res.result)), newData = []
              for (const i in oldData) {
                if (oldData[i].id != this.userInfo.id) {
                  newData.push(oldData[i])
                }
              }
              this.originChatData = res.result
              this.brushChatData(this.avaList)
            }
          }
        })
      }
    },
    mounted() {
      this.docHeight();
      this.globalClick();
      this.initThisList()
      imStore.dispatch('setSessionStatus', 1)
    }
  }
</script>
